package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.presentation.viewmodel.AuthViewModel
import com.iptvplayer.shared.presentation.viewmodel.HomeViewModel
import com.iptvplayer.web.ui.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun SettingsScreen(authVm: AuthViewModel, homeVm: HomeViewModel, onOpenSources: () -> Unit, onOpenDevices: () -> Unit) {
    val auth by authVm.state.collectAsState()
    val home by homeVm.state.collectAsState()

    PageContainer {
        H2(attrs = { style { property("margin", "0 0 16px") } }) { Text("Settings") }

        Div(attrs = { style { cardStyle(); property("padding", "18px"); property("margin-bottom", "12px") } }) {
            Div(attrs = { style { property("font-size", "13px"); property("color", Theme.textDim); property("margin-bottom", "4px") } }) { Text("Account") }
            Div(attrs = { style { property("font-size", "16px"); property("font-weight", "600") } }) { Text(auth.user?.username ?: "—") }
            Div(attrs = { style { property("font-size", "14px"); property("color", Theme.textDim) } }) { Text(auth.user?.email ?: "") }
        }

        SettingRow("IPTV Sources", "Add, edit or remove Xtream / M3U providers") {
            GhostButton("Manage") { onOpenSources() }
        }
        SettingRow("Devices", "Rename or remove your signed-in devices") {
            GhostButton("Manage") { onOpenDevices() }
        }
        SettingRow("Content", if (home.isLoading) "Refreshing…" else "Re-fetch all channels & movies") {
            GhostButton(if (home.isLoading) "Refreshing…" else "Refresh all") { homeVm.refresh() }
        }

        Div(attrs = { style { property("margin-top", "20px") } }) {
            Button(attrs = {
                onClick { authVm.logout() }
                style {
                    property("background", "transparent"); property("color", Theme.danger)
                    property("border", "1px solid ${Theme.danger}"); property("border-radius", "8px")
                    property("padding", "10px 16px"); property("font-size", "15px"); property("cursor", "pointer")
                }
            }) { Text("Log out") }
        }
    }
}

@Composable
private fun SettingRow(title: String, subtitle: String, action: @Composable () -> Unit) {
    Div(attrs = {
        style {
            cardStyle(); display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.SpaceBetween)
            property("gap", "12px"); property("padding", "14px 16px"); property("margin-bottom", "10px")
        }
    }) {
        Div {
            Div(attrs = { style { property("font-size", "15px"); property("font-weight", "600") } }) { Text(title) }
            Div(attrs = { style { property("font-size", "13px"); property("color", Theme.textDim) } }) { Text(subtitle) }
        }
        action()
    }
}
